import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { TrashIcon } from "../../components/Icon";
import "./imagePreview.scss"

let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
let blobToken = process.env.REACT_APP_BLOB_TOEKN;

export const imagePreview = (data: any, index: number, getImageDetails: Function, handleEditFileList: Function, setShowPopUpContentModal?: any, isDelete?: boolean) => {
    let file_type = data.file_url.split(".")
    return (
        <>
            <div className="mt-3 mr-4 d-flex align-center justify-center " key={index}>
                <div className="uploaded_file_name pointer d-flex" onClick={() => {
                    getImageDetails(data)
                    setShowPopUpContentModal((prev: boolean) => !prev)
                }}>
                    {data?.file_name?.length > 10 ?

                        (<OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 250 }}
                            overlay={<Tooltip id="button-view-open-item">
                                {data?.file_name}
                            </Tooltip>}
                        >
                            <div>{data?.file_name?.substring(0, 7) + "..." + file_type[1]}</div>
                        </OverlayTrigger>)
                        :
                        data?.file_name}
                </div>
                {isDelete && <div
                    className="pointer ml-2"
                    onClick={() => {
                        handleEditFileList?.(index)
                    }}
                >
                    <TrashIcon />
                </div>}
            </div>
        </>
    );

}

export const singleImagePreview = (data: any, index: number, getImageDetails: Function, handleEditFileList: Function, setShowPopUpContentModal: any, isDelete: boolean, uploadData?: any) => {
    let file_type = data?.file_url?.split(".")
    const colorChange = () => {
        for (let i in uploadData) {
            if (document.getElementById(`color${i}`) != null) {
                let byDefaultColor: any = document.getElementById(`color${i}`)
                byDefaultColor.style.color = 'rgb(71, 69, 69)'
                byDefaultColor.className = "uploaded_file_name pointer d-flex side-bar"
            }
        }
        const id = `color${index}`
        let activeColor: any = document.getElementById(id)
        activeColor.style.color = 'red'
        activeColor.className = "side-bar-static uploaded_file_name pointer d-flex side-bar"
    }
    return (
        <>
            <div className='d-flex'>
                <li className={index == 0 ? "side-bar-static uploaded_file_name pointer d-flex side-bar" : "uploaded_file_name pointer d-flex side-bar"} id={`color${index}`} style={{ color: index == 0 ? "red" : "rgb(71, 69, 69)", marginTop: '2px', marginBottom: '2px', padding: '5px', width: '122px', textDecorationColor: 'rgb(71, 69, 69)', fontSize: '12px' }} onClick={() => {
                    colorChange()
                    getImageDetails(data, index)
                    setShowPopUpContentModal((prev: boolean) => !prev)
                }}>
                    {data?.file_name?.length > 10 ?

                        (<OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 250 }}
                            overlay={<Tooltip id="button-view-open-item">
                                {data?.file_name}
                            </Tooltip>}
                        >
                            <>{data?.file_name?.slice(0, 7) + "..." + file_type[file_type?.length - 1]}</>
                        </OverlayTrigger>)
                        :
                        data?.file_name}
                </li>
                {isDelete && <div
                    className="pointer ml-2 mr-2"
                    onClick={() => {
                        handleEditFileList?.(index)
                    }}
                >
                    <TrashIcon />
                </div>}
            </div>
        </>
    );

}

export const downloadLink = (data: any, index: number, getImageDetails: Function, handleEditFileList: Function, setShowPopUpContentModal: any, isDelete: any) => {
    return (
        <>
            <div className="d-flex align-center justify-center mt-3 mr-4" key={index} onClick={() => setShowPopUpContentModal((prev: boolean) => !prev)} >
                <a
                    href={
                        data?.file_url
                            ? `${blobBaseUrl}${data?.file_url}?${blobToken}`
                            : ""
                    }
                    className="uploaded_file_name"
                >
                    {data?.file_name?.length > 10 ?

                        (<OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 250 }}
                            overlay={<Tooltip id="button-view-open-item">
                                {data?.file_name}
                            </Tooltip>}
                        >
                            <div>{data?.file_name?.substring(0, 10) + "..."}</div>
                        </OverlayTrigger>)
                        :
                        data?.file_name}
                </a>
                {isDelete && <a
                    className="pointer  ml-2"
                    onClick={() => handleEditFileList?.(index)}
                >
                    <TrashIcon />
                </a>}
            </div>
        </>
    );
}


export const renderUploadedFiles = (showPopUpContentModal: boolean, setShowPopUpContentModal: any, renderFilesList: Function) => {
    return (
        <div>
            <div>
                <div className="mr-3" style={{ display: "flex", flexWrap: "wrap" }}>{renderFilesList()} </div>
            </div>
        </div>
    )
};


export const handleHsnValidation = (value: string, clientMappedHSNData: any, setInvoiceWarning: any) => {
    if (!clientMappedHSNData?.client_turnover || !clientMappedHSNData?.is_hsn_sac_code_check_active) {
        setInvoiceWarning && setInvoiceWarning((prev: any) => ({
            ...prev,
            hsnWarning: '',
        }));


        return;
    }
    const turnover = parseFloat(clientMappedHSNData?.client_turnover || '0');
    const hsnLength = !!value ? String(value)?.length : 0;

    if (turnover <= 50000000) {
        if (hsnLength < 4) {
            setInvoiceWarning && setInvoiceWarning((prev: any) => ({
                ...prev,
                hsnWarning:
                    'HSN code should be at least 4 digits when turnover is less than or equal to 5 crore.',
            }));
        } else {
            setInvoiceWarning && setInvoiceWarning((prev: any) => ({
                ...prev,
                hsnWarning: '',
                hsnError: '',
            }));
        }
    } else {
        if (hsnLength < 6) {
            setInvoiceWarning && setInvoiceWarning((prev: any) => ({
                ...prev,
                hsnWarning:
                    'HSN code should be minimum 6 digits when turnover is greater than 5 crore.',
            }));
        } else {
            setInvoiceWarning && setInvoiceWarning((prev: any) => ({
                ...prev,
                hsnWarning: '',
            }));
        }
    }
};


export const handleCheckHsnValidation = (value: string, clientMappedHSNData: any, setInvoiceWarning: any) => {
    if (!clientMappedHSNData?.client_turnover || !clientMappedHSNData?.is_hsn_sac_code_check_active) {


        return false;
    }
    const turnover = parseFloat(clientMappedHSNData?.client_turnover || '0');
    const hsnLength = !!value ? String(value)?.length : 0;

    if (turnover <= 50000000) {
        if (hsnLength < 4) {


            return true
        } else {


            return false
        }
    } else {
        if (hsnLength < 6) {


            return true
        } else {


            return false
        }
    }
};


export const handleHsnSacCheckForStock = (hsnSacValue: string | number, clientMappedHSNData: any, setHsnWarning: any, setFormError: any) => {
    if (!clientMappedHSNData?.client_turnover || !clientMappedHSNData?.is_hsn_sac_code_check_active) {
        setHsnWarning((prev: any) => ({
            ...prev,
            hsnWarning: '',
        }));
        setFormError((prev: any) => ({
            ...prev,
            hsnError: '',
        }));

        return;
    }

    const turnover = parseFloat(clientMappedHSNData?.client_turnover);
    const hsnLength = !!hsnSacValue ? String(hsnSacValue)?.length : 0;

    if (turnover <= 50000000) { // Turnover <= 5 crore
        if (hsnLength < 4) {
            setHsnWarning((prev: any) => ({
                ...prev,
                hsnWarning: 'HSN code should be at least 4 digits when turnover is less than or equal to 5 crore.',
            }));
        } else {
            setHsnWarning((prev: any) => ({
                ...prev,
                hsnWarning: '',
            }));
            setFormError((prev: any) => ({
                ...prev,
                hsnError: '',
            }));
        }
    } else {
        if (hsnLength < 6) {
            setHsnWarning((prev: any) => ({
                ...prev,
                hsnWarning: 'HSN code should be minimum 6 digits when turnover is greater than 5 crore.',
            }));
        } else {
            setHsnWarning((prev: any) => ({
                ...prev,
                hsnWarning: '',
            }));
            setFormError((prev: any) => ({
                ...prev,
                hsnError: '',
            }));
        }
    }
};

export const renderDocumentType = (label: string | undefined) => {
    if (label === "Invoice" || label === "Tax Invoice RCM applicable" || label === "Tax Invoice") {
        return "Invoice";
    }
    return `${label}`;
}
